/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto as SecurityUserDto } from '../../models/security/user-dto';

export interface GetLoggedInUser$Params {
}

export function getLoggedInUser(http: HttpClient, rootUrl: string, params?: GetLoggedInUser$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityUserDto>> {
  const rb = new RequestBuilder(rootUrl, getLoggedInUser.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityUserDto>;
    })
  );
}

getLoggedInUser.PATH = '/security/user';

